import { Roles } from '../../../authentication/data-access/models/auth.model';
import { savedFileStatus } from '../../data-access/models/savedFilesStatus.model';
import { DocumentStatus } from '../../enums/documentStatus';
import { getSUDocumentStatus } from './suApplicationStatusUpdate.function';

export function getDocumentStatus(
  fileStatus: savedFileStatus,
  roles: Roles[],
  documentType: string,
  isPayment: boolean = false,
  invoiceStatus?: DocumentStatus,
): DocumentStatus {
  if (roles.includes(Roles.FIRST_APPROVER)) {
    return handleFirstApprover(fileStatus, isPayment, documentType);
  } else if (roles.includes(Roles.SECOND_APPROVER)) {
    return handleSecondApprover(fileStatus);
  } else if (roles.includes(Roles.THIRD_APPROVER)) {
    return handleThirdApprover(fileStatus, isPayment, invoiceStatus);
  } else {
      return handleDefault(fileStatus);
  }
}

function handleFirstApprover(fileStatus: savedFileStatus, isPayment: boolean, documentType: string): DocumentStatus {
  if (fileStatus.isSaveForLater) {
    return DocumentStatus.PENDING;
  }
  return isPayment ? DocumentStatus.APPROVED : DocumentStatus.IN_REVIEW ;
}

function handleSecondApprover(fileStatus: savedFileStatus): DocumentStatus {
  return fileStatus.hasRequestedChanges
    ? DocumentStatus.PENDING
    : DocumentStatus.APPROVED;
}

function handleThirdApprover(fileStatus: savedFileStatus, isPayment: boolean, invoiceStatus?: DocumentStatus): DocumentStatus {
  if (fileStatus.isSaveForLater) {
    return invoiceStatus!;
  }
  if(fileStatus.hasRequestedChanges)
  {
    return DocumentStatus.PENDING
  }
  return isPayment ? DocumentStatus.APPROVED : getSUDocumentStatus(invoiceStatus!,false,true);
}

function handleDefault(fileStatus: savedFileStatus): DocumentStatus {
  return fileStatus.hasRequestedChanges
    ? DocumentStatus.PENDING
    : DocumentStatus.IN_REVIEW;
}
